import React from 'react';
import { AlertTriangle } from '@saleshandy/icons';
import ImageIcon from '../images/image-icon';
import { Images } from '../../app-constants';

type ScheduleUsageWarningBannerProps = {
  otherSequenceCount: number;
};

const ScheduleUsageWarningBanner: React.FC<ScheduleUsageWarningBannerProps> = ({
  otherSequenceCount,
}) => (
  <div className="bs-schedule-form__warning-banner" role="status">
    <ImageIcon src={Images.InfoCircleDown} alt="warning-triangle" />
    <div className="bs-schedule-form__warning-banner-text">
      <span className="bs-schedule-form__warning-banner-title">
        This schedule is also used by {otherSequenceCount} other sequence
        {otherSequenceCount === 1 ? '' : 's'}
      </span>
      <p className="bs-schedule-form__warning-banner-description">
        Changes here will affect all of them. Want timing specific to this
        sequence? Create and assign a new schedule.
      </p>
    </div>
  </div>
);

export default ScheduleUsageWarningBanner;
